module.exports = __webpack_public_path__ + "assets/dd28238dff513af58dbf241e9892f428.mp3";